import { createFileRoute } from "@tanstack/react-router";
import { JobsPage, validateJobsSearch } from "@/features/jobs/jobs-page";

export const Route = createFileRoute("/_app/jobs")({
  head: () => ({ meta: [{ title: "Jobs · Malfak" }] }),
  validateSearch: validateJobsSearch,
  component: JobsPage,
});
